import React, {useEffect, useState} from 'react'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormSelect from "../../../components/atoms/Select";
import {
    handleFind, isNullOrUndefinded,
} from "../../../helper/utils";
import PageTable from "../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { cuadroRequerimientosReprocesarCuadroSedeAPI} from "../../../consumers/backendApisUrls";
import ReasignarResponsable from "./modales/ReasignarResponsable";
import MensajeConfirmacionModal from "./modales/MensajeConfirmacionModal";
import {useHistory} from "react-router-dom";


const TableListarCuadroRequerimientos = ({
                         formValues,
                         setFormValues,
                         extraData,
                         setModalEnabled,
                         paginator,
                         setPaginator,
                         keys: KEYS,
                         manageSearch,
                         fromAdminPage
                     }) => {
    const [executePost] = useManagePostRequest();
    const history = useHistory();

    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (!isNullOrUndefinded(formValues?.Items))
            setRows(formValues.Items)
    }, [formValues.Items]);


    const reprocesarCuadroSede = async (idCuadroSede) => {
        setRows(prevRows =>
            prevRows.map(row =>
                row.IdCuadroSede === idCuadroSede
                    ? { ...row, EstaReprocesando: true }
                    : row
            )
        );

        const api = cuadroRequerimientosReprocesarCuadroSedeAPI(idCuadroSede);
        const payload = {  };
        await executePost(api, payload, () => reprocesarCuadroSedeCallbackSuccess(idCuadroSede), true, ()=>{}, true);
    }

    const reprocesarCuadroSedeCallbackSuccess = (idCuadroSede) => {
        manageSearch();

    }

    const HEADERS = [
        {col: "col-sm-1", label: "Fecha de Registro"},

        {
            col: "col-sm-3", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsSedes)}
                        description="Sede"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsSedes] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsSedes)}
                    />
                </div>
        },

        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsDepartamentos)}
                        description="Región"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsDepartamentos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsDepartamentos)}
                    />
                </div>
        },

        {col: "col-sm-2", label: "Responsable"},

        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsEstados)}
                        description="Estado"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstados] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstados)}
                    />
                </div>
        },

        {col: "col-sm-1", label: "Asignaciones Pendientes"},
        {col: "col-sm-1", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
            {rows.map((row) => (
                <tr key={row.IdCuadroSede}>
                    <td className="text-center">{row.FechaRegistro}</td>
                    <td className="text-center">{row.Sede}</td>
                    <td className="text-center">{row.Departamento}</td>
                    <td className="text-center">{row.Responsable}</td>
                    <td className="text-center">{row.Estado}</td>
                    <td className="text-center">{row.Pendientes}</td>

                    <td className="text-center">

                        <ActionsIcons>

                            {row.PuedeVerCuadroRequerimientos === true &&
                                <FontAwesomeIcon
                                    icon="id-card"
                                    title="Ver Cuadro Requerimientos"
                                    size="lg"
                                    className="hand-pointer"
                                    onClick={(e) => {
                                        if (e)
                                            e.preventDefault();
                                        history.push("/cuadroRequerimientos/"+row?.IdCuadroSede);
                                    }

                                    }
                                />
                            }

                            {row.PuedeReasignar === true &&
                                <FontAwesomeIcon
                                    icon="male"
                                    title="Reasignar Responsable"
                                    size="lg"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: ReasignarResponsable,
                                            data: {
                                                idCuadroSede : row.IdCuadroSede,
                                                nombreEmpleadoResponsable: row.Responsable,
                                                refreshPage: manageSearch
                                            },
                                        })
                                    }
                                />
                            }

                            {row.PuedeReprocesar === true &&
                            <FontAwesomeIcon
                                icon={faSync}
                                title={row?.EstaReprocesando === true ? "Reprocesando" : "Reprocesar"}
                                size="lg"
                                spin={row?.EstaReprocesando === true}
                                onClick={() =>
                                    {
                                        //reprocesarCuadroSede(row.IdCuadroSede)
                                        if (row?.EstaReprocesando !== true)
                                        setModalEnabled({
                                            isEnable: true,
                                            component: MensajeConfirmacionModal,
                                            data: {
                                                idCuadroSede : row.IdCuadroSede,
                                                reprocesarCuadroSede: reprocesarCuadroSede
                                            },
                                        })

                                    }
                                }
                            />}
                        </ActionsIcons>

                    </td>
                </tr>
            ))}
            </tbody>
        </PageTable>
    );
}

export default TableListarCuadroRequerimientos;
